import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { AlertTriangle, ShieldAlert, Check, X } from "lucide-react";

interface ConfirmationAlertProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  dict: any;
}

const ConfirmationAlert = ({ isOpen, onClose, onConfirm, dict }: ConfirmationAlertProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-[4px] p-6">
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="relative w-full max-w-md overflow-hidden rounded-3xl bg-[#0F172A] border border-red-500/30 shadow-[0_0_50px_rgba(220,38,38,0.15)]"
          >
            {/* Header Decorativ */}
            <div className="h-2 bg-gradient-to-r from-red-600 via-orange-500 to-red-600" />

            <div className="p-8">
              <div className="flex items-center gap-4 mb-6">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-red-500/10 text-red-500 border border-red-500/20 shadow-[0_0_15px_rgba(220,38,38,0.2)]">
                  <ShieldAlert size={32} />
                </div>
                <div>
                  <p className="text-[10px] font-black tracking-[0.2em] text-red-500 uppercase">{dict.title}</p>
                  <h3 className="text-2xl font-black text-white italic">{dict.subtitle}</h3>
                </div>
              </div>

              <div className="space-y-4 mb-8">
                <p className="text-slate-300 text-sm leading-relaxed">
                  {dict.description}
                </p>
                <div className="rounded-xl bg-red-500/5 border border-red-500/10 p-4">
                                  <ul className="space-y-3">
                                    {dict.info && dict.info.map((line, index) => (
                                      <motion.li
                                        key={index}
                                        initial={{ opacity: 0, x: -10 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ delay: index * 0.1 }}
                                        className="flex gap-3 text-xs text-slate-400"
                                      >
                                        <div className="mt-1 shrink-0">
                                          <AlertTriangle size={14} className="text-orange-500" />
                                        </div>
                                        <span className="leading-tight">{line}</span>
                                      </motion.li>
                                    ))}
                                  </ul>
                                </div>
              </div>

              <div className="flex gap-3">
                <button
                  onClick={onClose}
                  className="flex-1 px-6 py-3 rounded-xl border border-slate-700 bg-slate-800/50 text-slate-300 text-xs font-black uppercase tracking-widest hover:bg-slate-700 transition-colors"
                >
                  {dict.btnCancel}
                </button>
                <button
                  onClick={onConfirm}
                  className="flex-1 px-6 py-3 rounded-xl bg-red-600 text-white text-xs font-black uppercase tracking-widest hover:bg-red-500 transition-all shadow-[0_0_20px_rgba(220,38,38,0.3)] flex items-center justify-center gap-2"
                >
                  {dict.btnConfirm} <Check size={16} />
                </button>
              </div>
            </div>

            {/* Fundal decorativ subtil */}
            <div className="absolute -bottom-12 -right-12 opacity-[0.03] pointer-events-none">
                <AlertTriangle size={200} />
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default ConfirmationAlert;